export default "__VITE_ASSET__5hAySTiz__"